/**
 * WordPress dependencies
 */
import { useState, useEffect, useContext } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { Button } from "@wordpress/components";

import PatternContext from '../Context/PatternContext';

const PatternDependencyModal = () => {

    const patternContext = useContext(PatternContext);
    const isAfterSave = patternContext.useAfterSave();

    const [currentPluginIndex, setCurrentPluginIndex] = useState(false);
    const [statusMessages, setStatusMessages] = useState([]);
    const [activatedPluginIndex, setActivatedPluginIndex] = useState([]);
    const [importProceed, setImportProceed] = useState(false);

    const depenency_plugins_list = PatLocalize.depenency_plugins_list;

    let pattern_dependency_plugins  = [];
    if(patternContext.dependencyPlugins) {
        pattern_dependency_plugins  = patternContext.dependencyPlugins.split(',');
    }

    useEffect(() => {
        if(importProceed) {
            if (currentPluginIndex < pattern_dependency_plugins.length) {
                let pluginSlug = pattern_dependency_plugins[currentPluginIndex];

                activatePlugin(depenency_plugins_list[pluginSlug], pluginSlug);
            } else {
                // After all plugin is activated.
                setStatusMessages((prevMessages) => [...prevMessages, 'All plugins activated']);
                setCurrentPluginIndex(false);
                setImportProceed(false);

                let slug = patternContext.dependencyPluginSlug;

                let importBtn = document.querySelector('.pat-proceed-import-btn span');
                importBtn.innerText = __('Parsing content..', 'patternly');

                if(slug) {
                    setTimeout(function(){
                        patternContext.setImportPatternSlug(slug);
                        patternContext.setImportAndSave(true);
                        patternContext.setImportPattern(true);
                        
                    }, 1000)
                }
            }
        }
    }, [currentPluginIndex, importProceed]);

    useEffect( () => {
        if ( isAfterSave ) {
            //after saving the content.
            setTimeout(function(){
                //@TODO display redirect buttons.
                let importBtn = document.querySelector('.pat-proceed-import-btn span');
                    importBtn.innerText = __('Done!', 'patternly');
            }, 1000)

        }
    }, [ isAfterSave ] );

    const activatePlugin = async (plugin, pluginSlug) => {
        let url = PatLocalize.homeurl + "/wp-json/optemiz/v1/patternly/activate_plugins";

        const data = {
            'nonce': PatLocalize.nonce,
            'plugin_slug': pluginSlug
        }

        await fetch(url, {
            method: 'POST',
            body: JSON.stringify(data),
        })
        .then( response => {
            return response.json();
        } )
        .then( function(response) {

            if (response.success) {
                setStatusMessages((prevMessages) => [...prevMessages, `${plugin.name} activated`]);
                setCurrentPluginIndex(currentPluginIndex + 1);

                // clone with unique values.
                let cloneActivatedPluginIndex = activatedPluginIndex;

                cloneActivatedPluginIndex.push(currentPluginIndex);

                setActivatedPluginIndex(cloneActivatedPluginIndex);
            } else {
                setStatusMessages((prevMessages) => [...prevMessages, `Error activating ${plugin.name}: ${response.message}`]);
            }
        })
    };

    const hideDependencyModal = () => {
        patternContext.setDependencyPluginSlug('');
        patternContext.setDependencyPlugins('');
        patternContext.setDependencyModalStatus(false);
        setActivatedPluginIndex([]);
    }

    const importProceedHandler = (event) => {

        let importBtn = event.target.closest('.pat-proceed-import-btn span');

        if(importBtn) {
            importBtn.innerText = __('Plugins activating..', 'patternly');
        }

        setTimeout(function(){
            setCurrentPluginIndex(0);
            setImportProceed(true);
        }, 1000)
    }

    if(!patternContext.dependencyModalStatus) {
        return;
    }

    const dependencyPluginList = () => {
        let pluginListDisplay = '';

        if(pattern_dependency_plugins.length > 0) {
            let counter = 0;
            pluginListDisplay = pattern_dependency_plugins.map((slug, index) => {
                let plugin = depenency_plugins_list[slug];
                let classes = activatedPluginIndex.includes(counter) ? 'pat-is-plugin-activated' : '';

                counter++;

                return(
                    <li key={index} className={classes}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" class="h-7 w-7 "><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clip-rule="evenodd"></path></svg>
                        <span>{plugin.name}</span>
                    </li>
                )
            })
        }

        return pluginListDisplay;
    }

    return (
        <>
            <div className="pat-dependency-modal">
                <div className="pat-dependency-modal-inner">

                    <div className="pat-dependency-modal-inner-content">
                        <h2>{__('Okay, just one last step', 'patternly')}</h2>
                        <p>{__('You are close to importing the template. To complete the process, we need to activate the following dependency plugins first.', 'patternly')}</p>

                        <ul>
                            {dependencyPluginList()}
                        </ul>

                        <div className="pat-dependency-modal-buttons">
                            <a 
                            class="pat-btn pat-btn-primary pat-proceed-import-btn" 
                            onClick={importProceedHandler}
                            data-slug="">
                                <span>{__('Proceed Import', 'patternly')}</span>
                                <img src={`${PatLocalize.pat_plugin_url}/src/admin/assets/images/proceed-import.svg`} alt="" />
                            </a>

                            <a 
                                className="pat-btn pat-btn-secondary-link"
                                onClick={hideDependencyModal}
                            >{__('Cancel', 'patternly')}</a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PatternDependencyModal;